exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-channels-tsx": () => import("./../../../src/pages/channels.tsx" /* webpackChunkName: "component---src-pages-channels-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-index-working-tsx": () => import("./../../../src/pages/index-working.tsx" /* webpackChunkName: "component---src-pages-index-working-tsx" */)
}

